import styles from '../assets/styles/RandomDiversity2026Ticket.module.css';

export default function MemoryLanguageChoice({ onChoose }) {
  return <div className={styles.languageChoice}>
    <span className={styles.fieldNumber}>00 / LANGUAGE</span>
    <h2>결과물의 언어를 선택해 주세요.</h2>
    <p>Choose the language for your poem and emotion words.</p>
    <p>사진과 이야기를 등록하기 전에 선택해 주세요. 저장 후에는 바꿀 수 없습니다.</p>
    <div className={styles.languageButtons}>
      <button type="button" className={styles.primaryButton} onClick={() => onChoose('ko')}>한국어</button>
      <button type="button" className={styles.secondaryButton} onClick={() => onChoose('en')}>English</button>
    </div>
  </div>;
}
